/**
 * Converts an array into a nested object with child elements.
 *
 * @param {Array} list
 *
 * @return {Object}
 */
export function arrayToNested(list) {
  if (!list || list.length === 0) {
    return null;
  }

  if (list.length === 1) {
    return { ...list[0] };
  }

  const result = { ...list[0] };

  let current = result;

  for (let i = 1; i < list.length; i++) {
    const child = { ...list[i] };
    current.child = child;
    current = child;
  }

  return result;
}

export function nestedToArray(nested) {
  const result = [];

  let current = nested;
  while (current != null) {
    // Clone the current object (without the 'child' property)
    const { child, ...item } = current;
    result.push(item);
    current = child;
  }

  return result;
}
